import { render, staticRenderFns } from "@/templates/bookings/bookingDetail.html?vue&type=template&id=25367486&scoped=true&"
import script from "./BookingDetail.vue?vue&type=script&lang=js&"
export * from "./BookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=25367486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25367486",
  null
  
)

export default component.exports